import React from 'react';
import Section from '../ui/Section';
import { CheckCircle } from 'lucide-react';

const About = () => {
    const highlights = [
        "Led by Alija Kolaković, MSc. in Civil Engineering",
        "Specialized in Residential & Business Centers",
        "Infrastructure & Urban Facilities",
        "Sustainable & Cost-Effective Solutions"
    ];

    return (
        <Section id="about" background="white">
            <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                    <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">
                        About <span className="text-gold-600">Us</span>
                    </h2>
                    <p className="text-slate-600 mb-6 text-lg leading-relaxed">
                        NOPA Engineering is a professional civil engineering studio led by Alija Kolaković, MSc. in Civil Engineering. With a strong focus on quality, precision, and modern structural design, the studio delivers projects ranging from residential buildings and business centres to complex infrastructure such as bridges and urban facilities.
                    </p>
                    <p className="text-slate-600 mb-8 text-lg leading-relaxed">
                        Our work integrates structural expertise, architectural sensibility, and technical documentation, ensuring sustainable and cost-effective solutions for investors.
                    </p>
                    <div className="space-y-4">
                        {highlights.map((item, index) => (
                            <div key={index} className="flex items-center gap-3">
                                <CheckCircle className="text-gold-500 w-6 h-6 flex-shrink-0" />
                                <span className="text-slate-700 font-medium">{item}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="relative h-[400px] rounded-lg overflow-hidden shadow-xl">
                    <img
                        src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=1931&auto=format&fit=crop"
                        alt="Civil Engineer at work"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                </div>
            </div>
        </Section>
    );
};

export default About;
